// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2-vDM","notes":"Notes_notes__26064","note":"Notes_note__2gSQ9","markdown":"Notes_markdown__DIbTK"};